import ReactionEmoji from "./ReactionEmoji";
import { useReactions } from "./ReactionsContext";
import styles from "./ReactionWidget.module.css";

export default function ReactionWidget() {
  const state = useReactions();

  if (!state || state.error || state.reactions.length === 0) {
    return null;
  }

  const { reactions, userReaction, isSubmitting, toggleReaction } = state;

  return (
    <div className={styles.reactionWidget}>
      <h4 className={styles.reactionWidgetTitle}>感想</h4>
      <div className={styles.reactionEmojiList}>
        {reactions.map((reaction) => (
          <ReactionEmoji
            key={reaction.id}
            reaction={reaction}
            selected={userReaction === reaction.id}
            disabled={isSubmitting}
            onToggle={(id) => {
              void toggleReaction(id);
            }}
          />
        ))}
      </div>
    </div>
  );
}
